import { useState, useEffect } from 'react'
import { collectionsApi } from '../services/collectionsApi'
import type { Collection } from '../types/collections'

export const useCollection = (collectionId: number) => {
  const [data, setData] = useState<Collection | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        setIsLoading(true)
        const collection = await collectionsApi.get(collectionId, false) // Don't include items by default
        setData(collection)
        setError(null)
      } catch (err) {
        setError('Error fetching collection')
        console.error('Error fetching collection:', err)
      } finally {
        setIsLoading(false)
      }
    }

    if (collectionId) {
      fetchCollection()
    }
  }, [collectionId])

  return { data, isLoading, error }
}